import { LinkOverrides } from '../types';

export const melioLinksOverrides: LinkOverrides = {
  helpCenter: 'https://melio.zendesk.com/hc/en-us',
  failedToCollectSupport: '',
  verifyBankAccountWithMicroDeposit:
    'https://melio.zendesk.com/hc/en-us/articles/4447505319314-Connecting-your-bank-account-with-micro-deposits?utm_campaign=MDRTP&utm_medium=email&utm_source=tranactional',
};
